var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTesseractHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29302",
    "data-name": "Group 29302",
    transform: "translate(-1232 11067.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(1232 -11067.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29296",
    "data-name": "Group 29296",
    transform: "translate(1012 -11275.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49710",
    "data-name": "Path 49710",
    d: "M32.106,2.715,25.552,0,19,2.715,16.9,9.179l2.555,6.192,6.1,2.527,6.553-2.077L34.82,9.268Z",
    transform: "translate(221.716 216)",
    fill: "#00d7df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49711",
    "data-name": "Path 49711",
    d: "M15.822,88.084,9.268,90.8,2.714,88.084,0,81.531l2.714-6.554L1.292,81.531l2.336,5.64,5.64,2.336Z",
    transform: "translate(238 143.738)",
    fill: "#00aadf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49712",
    "data-name": "Path 49712",
    d: "M13.9,11.187l4.634-1.919h0L13.9,7.349l1.919-4.634L11.187,4.634,9.268,0h0L7.349,4.634,2.715,2.715,4.634,7.349,0,9.268H0l4.634,1.919L2.715,15.821,7.349,13.9l1.919,4.634h0L11.187,13.9l4.634,1.919Z",
    transform: "translate(238 216)",
    fill: "#30c7f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49713",
    "data-name": "Path 49713",
    d: "M136.473,132.634l.8,1.919-1.92.8-.8,1.92-1.919-.8-1.919.8-.8-1.92-1.92-.8.8-1.919-.8-1.919,1.92-.8.8-1.92,1.919.8,1.919-.8.8,1.92,1.92.8Z",
    transform: "translate(114.634 92.634)",
    fill: "#00aadf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49714",
    "data-name": "Path 49714",
    d: "M155.72,154.6l1.919-.8h0l-1.919-.8.8-1.919-1.919.8-.8-1.919h0l-.8,1.919-1.919-.8.8,1.919-1.919.8h0l1.919.8-.8,1.919,1.919-.8.8,1.919h0l.8-1.919,1.919.8Z",
    transform: "translate(93.467 71.467)",
    fill: "#51c7ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49715",
    "data-name": "Path 49715",
    d: "M206.51,204.954l.306.738-.738.306a.149.149,0,0,0-.081.081l-.306.738-.738-.306a.15.15,0,0,0-.114,0l-.738.306-.306-.738a.149.149,0,0,0-.081-.081l-.738-.306.306-.738a.149.149,0,0,0,0-.114l-.306-.738.738-.306a.149.149,0,0,0,.081-.081l.306-.738.738.306a.149.149,0,0,0,.114,0l.738-.306.306.738a.149.149,0,0,0,.081.081l.738.306-.306.738A.15.15,0,0,0,206.51,204.954Z",
    transform: "translate(42.371 20.372)",
    fill: "#b3e5ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesseractHighlighted);
export default __webpack_public_path__ + "static/media/tesseractHighlighted.2d9582fb27bae325399af2c0430605b0.svg";
export { ForwardRef as ReactComponent };